<div class="info-page">
	<div class="info-page-container">
		<div class="info-page-header">
			<span class="text-4xl">Impressum</span>
			<span class="text-xl">Angaben gemäß § 5 TMG:</span>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Patriacura ist eine Marke der Aliacura e.K.

			</div>
			<div class="text-block-content">
				<p>Dr. Philipp Hohnstein</p>
				<p>Hauptstraße 4</p>
				<p>91443 Scheinfeld</p>
				<p>Deutschland</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Handelsregister:
			</div>
			<div class="text-block-content">
				<p>HRA 11249</p>
				<p>Registergericht: Amtsgericht Fürth</p>

			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Kontakt:
			</div>
			<div class="text-block-content">
				<p>Telefon: 09162 7103</p>
				<p>Telefax: 09841 2297</p>
				<p>E-Mail: info&#64;patriacura.de</p>

			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
			</div>
			<div class="text-block-content">
				<p>DE297740030</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Angaben zur Berufshaftpflichtversicherung:
			</div>
			<div class="text-block-content">
				<p>Name und Sitz des Versicherers:</p>
				<p>Nürnberger Versicherung</p>
				<p>Ostendstraße 100</p>
				<p>90334 Nürnberg</p>
				<p>Telefon: +49 911 531-5</p>
				<p>Fax: +49 911 531-3206</p>
				<p>Geltungsraum der Versicherung: weltweit mit Ausnahme von USA und Kanada</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
			</div>
			<div class="text-block-content">
				<p>Dr. Philipp Hohnstein</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				EU-Streitschlichtung:
			</div>
			<div class="text-block-content">
				<p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
				<p>https://ec.europa.eu/consumers/odr/. </p>
				<p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>

			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Verbraucherstreitbeilegung/Universalschlichtungsstelle:
			</div>
			<div class="text-block-content">
				<p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
					Verbraucherschlichtungsstelle teilzunehmen.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Hinweis zur Verantwortlichkeit ärztlicher Leistungen:
			</div>
			<div class="text-block-content">
				<p>Die Aliacura e.K. betreibt ausschließlich das technische Arztportal.</p>
				<p>Die auf dieser Plattform präsentierten ärztlichen Leistungen werden nicht von der Aliacura e.K.
					angeboten, sondern eigenverantwortlich von den jeweils aufgeführten Ärztinnen und Ärzten
					erbracht.</p>
				<p>Diese sind eigenverantwortlich für die medizinischen Inhalte ihrer Profile und die
					Leistungserbringung. </p>
				<p>Die rechtliche Verantwortung für die Inhalte liegt ausschließlich bei den
					jeweiligen Leistungserbringern.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Haftung für Inhalte:
			</div>
			<div class="text-block-content">
				<p> Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
					Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
				<p>Als Diensteanbieter sind wir gemäß §§ 8 bis 10 TMG nicht verpflichtet, übermittelte oder gespeicherte
					fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
					Tätigkeit hinweisen.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Haftung für Links:
			</div>
			<div class="text-block-content">
				<p>Unsere Plattform enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden Inhalte auch keine Gewähr.</p>
				<p>Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				Urheberrecht:
			</div>
			<div class="text-block-content">
				<p>Die durch die Aliacura e.K. erstellten Inhalte und Werke auf dieser Plattform unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. </p>
				<p>Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
			</div>
		</div>
	</div>
</div>
